import { User } from "./user.model";


// 1. Define the Enums
export enum CurrencyType {
    USD = 'USD',
    EUR = 'EUR',
    USDT = 'USDT',
    USDC = 'USDC',
}

export enum NetworkType {
    ERC = 'ERC',
    TRC = 'TRC',
}

  
  // 3. The Main Interface
export interface DaisyPayoutRegister {
    id: number;
    date: Date;
    network: NetworkType;
    currency: CurrencyType;
    amount: number;
    hash: string;
    wallet: string;
    user_id: number;

    user?: User;
}